import React, { useContext } from "react";
import { Table } from "react-bootstrap";
import { isMobile, isSafari } from "react-device-detect";
import PendingTableHeader from "./PendingTableHeader";
import PendingTableRow from "./PendingTableRow";
import { ChemBioPendingContext } from "../../ChemBioPendingContext";

const PendingTable = () => {
  const {
    pendingFlag,
    pendingTableData,
  } = useContext(ChemBioPendingContext);
  return (
    <Table bordered hover className={`table ${isMobile || isSafari ? " SafariTableDisplay" : ""}`}>
      {pendingFlag
      && (
        <PendingTableHeader />
      )}
      <tbody>
        {pendingFlag && pendingTableData.List.map((data, index) => (
          <PendingTableRow key={index} data={data} />
        ))}
      </tbody>
    </Table>
  );
};

export default PendingTable;
